exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: calc(100% - 40px);\n  height: calc(100% - 40px);\n  background-color: rgba(0, 0, 0, 0.9);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: white;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  font-size: 25px;\n  z-index: 999999999;\n  text-align: center;\n  padding: 20px; }\n  :host .header {\n    font-family: Lato;\n    font-size: 25px; }\n  :host .value {\n    font-family: WickedMouse, Mikodacs;\n    font-size: 30px; }\n  :host .claim {\n    font-family: Lato;\n    font-size: 30px;\n    color: #ef8200;\n    border: 1px solid #ef8200;\n    border-radius: 5px;\n    padding: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/jackpot-bubble/jackpot-bubble.component.scss
// module id = ../../../../../src/app/jackpot-bubble/jackpot-bubble.component.scss
// module chunks = 1